import { getConfig } from 'angieslist-app-platform/lib/common/poller/pollerActions';
import poller from 'angieslist-app-platform/lib/common/poller/pollerReducer';
import appDownload from '../../app/common/download/appDownloadReducer';
import businessList from './common/businessListReducer';
import home from './common/homeReducer';
import welcome from './common/welcomeReducer';
import serviceAreaMap from './common/serviceAreaMapReducer';
import performance from './common/performanceReducer';

export default {
  beforeConfigureStore: (options) => {
    const ionOptions = {
      reducers: {
        ...(options || {}).reducers,
        appDownload,
        businessList,
        home,
        performance,
        poller,
        welcome,
        serviceAreaMap,
      },
    };
    ionOptions.reducers.home.persist = true;
    return ionOptions;
  },
  afterConfigureStore: (store) => {
    if (process.env.IS_BROWSER) {
      store.dispatch(getConfig());
    }
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/injectors.js